.ux-phone-input {
  --ux-phone-input-flag-size: 44px;
  display: block;
  position: relative;
  font-family: var(--ux-font);

  .ux-input {
    border: var(--ux-input-border-width) solid var(--ux-input-border-color);
    flex: 1 1 auto;
    height: var(--ux-input-height);
    padding: var(--ux-input-padding-vertical) var(--ux-input-padding-horizontal);
    padding-left: calc(var(--ux-phone-input-flag-size) + var(--ux-select-icon-size) + var(--ux-input-padding-horizontal));

    &:hover {
      background-color: var(--ux-input-hover-bg);
      border-color: var(--ux-input-hover-border-color);
    }

    &:hover:not(:focus) {
      color: var(--ux-input-hover-text-color);
    }

    &:focus {
      border-color: var(--ux-input-focus-border-color);
      outline: var(--ux-input-focus-border-color) solid var(--ux-input-outline-width);
      outline-offset: var(--ux-input-outline-offset);
    }

    &:active {
      background-color: var(--ux-input-active-bg);
    }
  }

  ux-country-icon {
    flex: 0 0 auto;
    margin-right: 10px;

    [dir="rtl"] & {
      margin-left: 10px;
      margin-right: 0;
    }
  }

  &__inner {
    align-items: stretch;
    background-color: var(--ux-input-background-color);
    box-sizing: border-box;
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
    position: relative;
  }

  &--active {
    .ux-input {
      border-color: var(--ux-input-focus-border-color);
      outline: var(--ux-input-focus-border-color) solid var(--ux-input-outline-width);
      outline-offset: var(--ux-input-outline-offset);
    }
  }

  &--disabled {
    .ux-input {
      background-color: var(--ux-input-disabled-bg);
      border-color: var(--ux-input-disabled-border-color);
      color: var(--ux-input-disabled-text-color);
      opacity: var(--ux-input-disabled-opacity);
    }
  }

  &--error {
    .ux-input {
      border-color: var(--ux-input-error-border-color);
    }

    .ux-input:hover:not(:focus) {
      border-color: var(--ux-input-error-border-color);
    }
  }
}

.ux-phone-input__dropdown-button {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: 0 none transparent;
  border-radius: 0;
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  justify-content: space-between;
  left: 0;
  margin: 0;
  outline: none;
  padding: 0 10px 0 15px;
  position: absolute;
  top: 0;

  ux-icon {
    font-size: var(--ux-select-icon-size);
    transition: transform $animationSpeed-fast ease-out;

    .ux-phone-input--dropdown-opened & {
      transform: rotate(180deg);
    }
  }

  &--disabled {
    pointer-events: none;

    ux-icon,
    ux-country-icon {
      opacity: 0.5;
    }
  }
}

.ux-phone-input__dropdown {
  background-color: var(--ux-input-background-color);
  border: var(--ux-input-border-width) solid var(--ux-input-focus-border-color);
  border-top-width: 0;
  display: none;
  left: 0;
  max-height: (35px * 6) + 2px;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: $z-index-dropdown-element;

  .ux-phone-input--dropdown-opened & {
    display: block;
  }

  > ul {
    list-style: outside none;
    margin: 0;
    padding: 0;

    > li {
      align-items: center;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      padding: 5px $dim-15;
    }
  }

  .ux-phone-input__option {
    &.is-active,
    &:hover {
      background-color: $color-gray-background-menu;
    }
  }
}
